import { Box, Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { useTranslation } from 'react-i18next';
import { generatePath, Link } from 'react-router';
import { RoutePaths } from '../../routes/AppRoutes';
import FileUtils from '../../common/utils/file.utils';
import SizedImage from '../../common/components/SizedImage';
import { linkStyle } from '../../common/utils/style.utils';
import { ProductFragment } from '../products';

interface ProductNameToOptimizeListItemProps {
  product: ProductFragment;
  onOptimize: () => void;
}

export default function ProductNameToOptimizeListItem({ product, onOptimize }: ProductNameToOptimizeListItemProps): React.JSX.Element {
  const { t } = useTranslation(['products']);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'stretch', sm: 'center' },
        gap: 1.5,
        p: 1.5,
        borderRadius: 3,
        backgroundColor: 'surfaceContainerLowest.main',
        boxShadow: '0px 4px 7.5px rgba(0, 0, 0, 0.03)',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, minWidth: 0 }}>
        <SizedImage
          src={FileUtils.BuildPackagingImageUrl({
            photo: product.base_units[0]?.main_photo,
            type: product.sub_family,
            size: {
              height: 64,
              width: 64,
              fit: 'contain',
            },
          })}
          alt={t('products:csu')}
          width={64}
          height={64}
          borderRadius={0}
        />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, minWidth: 0 }}>
          <Typography
            variant="titleSmall"
            noWrap
            component={Link}
            to={generatePath(RoutePaths.PRODUCT, { productSku: `${product.sku}`, companyId: product.company_id })}
            sx={linkStyle}
          >
            {product.name}
          </Typography>
          <Typography variant="bodySmall" color="onSurfaceVariant">
            {t('products:name_optimization.item_warning')}
          </Typography>
        </Box>
      </Box>
      <Button variant="tonal" startIcon={<AutoAwesomeOutlinedIcon />} onClick={onOptimize} sx={{ height: 40, minHeight: 40, alignSelf: { xs: 'flex-end', sm: 'auto' } }}>
        {t('products:name_optimization.item_action')}
      </Button>
    </Box>
  );
}
